// src/constants/AdminBookingRequestConstants.js

// export const FETCH_BOOKING_REQUESTS_REQUEST = 'FETCH_BOOKING_REQUESTS_REQUEST'
// export const FETCH_BOOKING_REQUESTS_SUCCESS = 'FETCH_BOOKING_REQUESTS_SUCCESS'
// export const FETCH_BOOKING_REQUESTS_FAIL    = 'FETCH_BOOKING_REQUESTS_FAIL'

// export const ADMIN_FIND_NEAREST_DRIVER_REQUEST = 'ADMIN_FIND_NEAREST_DRIVER_REQUEST'
// export const ADMIN_FIND_NEAREST_DRIVER_SUCCESS = 'ADMIN_FIND_NEAREST_DRIVER_SUCCESS'
// export const ADMIN_FIND_NEAREST_DRIVER_FAIL    = 'ADMIN_FIND_NEAREST_DRIVER_FAIL'

// export const ADMIN_ACCEPT_BOOKING_REQUEST = 'ADMIN_ACCEPT_BOOKING_REQUEST'
// export const ADMIN_ACCEPT_BOOKING_SUCCESS = 'ADMIN_ACCEPT_BOOKING_SUCCESS'
// export const ADMIN_ACCEPT_BOOKING_FAIL    = 'ADMIN_ACCEPT_BOOKING_FAIL'

// export const RESET_ADMIN_BOOKING_REQUEST  = 'RESET_ADMIN_BOOKING_REQUEST'

// src/constants/AdminBookingRequestConstants.js

export const FETCH_BOOKING_REQUESTS_REQUEST = 'FETCH_BOOKING_REQUESTS_REQUEST'
export const FETCH_BOOKING_REQUESTS_SUCCESS = 'FETCH_BOOKING_REQUESTS_SUCCESS'
export const FETCH_BOOKING_REQUESTS_FAIL    = 'FETCH_BOOKING_REQUESTS_FAIL'

export const SET_ACCEPTED_REQIDS = 'SET_ACCEPTED_REQIDS'

export const ADMIN_FIND_NEAREST_DRIVER_REQUEST = 'ADMIN_FIND_NEAREST_DRIVER_REQUEST'
export const ADMIN_FIND_NEAREST_DRIVER_SUCCESS = 'ADMIN_FIND_NEAREST_DRIVER_SUCCESS'
export const ADMIN_FIND_NEAREST_DRIVER_FAIL    = 'ADMIN_FIND_NEAREST_DRIVER_FAIL'

export const ADMIN_ACCEPT_BOOKING_REQUEST = 'ADMIN_ACCEPT_BOOKING_REQUEST'
export const ADMIN_ACCEPT_BOOKING_SUCCESS = 'ADMIN_ACCEPT_BOOKING_SUCCESS'
export const ADMIN_ACCEPT_BOOKING_FAIL    = 'ADMIN_ACCEPT_BOOKING_FAIL'

export const RESET_ADMIN_BOOKING_REQUEST  = 'RESET_ADMIN_BOOKING_REQUEST'
export const ADMIN_CHECK_CONFLICT_REQUEST = 'ADMIN_CHECK_CONFLICT_REQUEST'
export const ADMIN_CHECK_CONFLICT_SUCCESS = 'ADMIN_CHECK_CONFLICT_SUCCESS'
export const ADMIN_CHECK_CONFLICT_FAIL    = 'ADMIN_CHECK_CONFLICT_FAIL'

export const ADMIN_CANCEL_BOOKING_REQUEST = 'ADMIN_CANCEL_BOOKING_REQUEST'
export const ADMIN_CANCEL_BOOKING_SUCCESS = 'ADMIN_CANCEL_BOOKING_SUCCESS'
export const ADMIN_CANCEL_BOOKING_FAIL    = 'ADMIN_CANCEL_BOOKING_FAIL'